
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 166","transform":"translate(-2367 -595)","fill":"#b1b6b9"}},[_c('path',{attrs:{"data-name":"Subtraction 2","d":"M2374 609a7 7 0 01-4.95-11.95 7 7 0 019.9 9.9A6.954 6.954 0 012374 609zm0-12.833a5.833 5.833 0 105.833 5.833 5.84 5.84 0 00-5.833-5.833z"}}),_c('circle',{attrs:{"data-name":"Ellipse 20","cx":"4","cy":"4","r":"4","transform":"translate(2370 598)"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/hierarchy-treeview/PN.svg